module.exports = __webpack_public_path__ + "static/media/avatar.09501bf6.svg";